<template>
	<div>
		<b-container
			style="
				margin: 0px !important;
				padding: 0px !important;
				max-width: none !important;
			">
			<b-row>
				<b-col cols="6">
					<span @click="currentPage--" v-if="currentPage > 1"
						>&lt; </span
					>{{ currentPage }} / {{ pageCount }}
					<span @click="currentPage++" v-if="currentPage < pageCount">
						&gt;</span
					>
					<pdf
						style="border: solid"
						:page="currentPage"
						@num-pages="pageCount = $event"
						v-bind:src="pdf_buffer" />
					<br />
				</b-col>
				<b-col cols="6">
					<div id="editor"></div>
					<b-button @click="dowloadXml">Télécharger</b-button>
					<span
						v-if="
							project &&
							project.details &&
							project.details.treatment_actions
						">
						<span
							v-for="(action, i) in project.details
								.treatment_actions"
							:key="i">
							<span v-if="action.type == 'xml'">
								&nbsp;<b-button
									@click="
										sendFileFtp(
											action.folder,
											action.project_uid
										)
									"
									>{{ action.name }}</b-button
								>
							</span>
						</span>
					</span>
					<br />
					<br />
				</b-col>
			</b-row>
			<b-row v-for="(obj, i) in alerts" :key="i">
				<b-col cols="12">
					<b-alert show :variant="obj.variant">{{
						obj.data
					}}</b-alert>
				</b-col>
			</b-row>
			<b-row v-for="(value, key) in array" :key="key">
				<b-col cols="1">
					<p>
						<strong>{{ key }}</strong>
					</p>
				</b-col>
				<b-col cols="11">
					<edit_tabulator
						:ref="'tab-' + key"
						:extern_file="false"
						@update="update(key, ...arguments)"></edit_tabulator>
				</b-col>
			</b-row>
		</b-container>
		<br /><br />
	</div>
</template>

<script>
	import pdf from "vue-pdf";
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import * as json2csv from "json2csv";
	import users from "../services/users.js";
	import edit_tabulator from "./edit_tabulator.vue";
	import treatments from "../services/treatments.js";

	var convert = require("xml-js");
	var format = require("xml-formatter");

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import utils from "../services/utils.js";

	export default {
		name: "viewXml",
		components: {
			pdf,
			edit_tabulator,
		},
		data() {
			return {
				check_update: false,
				pdf_buffer: null,
				tabulator: null,
				tabulator_data: null,
				xml: null,
				details: {},
				editor: null,
				currentPage: 1,
				pageCount: 0,
				name_file: "",
				json: null,
				array: {},
				main_key: "",
				order_keys: [],
				alerts: [],
			};
		},
		props: {
			project: {
				default: () => {},
			},
		},
		methods: {
			update(key, id, data) {
				if (this.check_update) {
					this.array[key] = data;

					var obj = {
						elements: [
							{
								elements: [],
								type: "element",
								name: this.main_key,
							},
						],
					};

					for (var i = 0; i < this.order_keys.length; i++) {
						var keys = Object.keys(
							this.array[this.order_keys[i]][0]
						);
						for (
							var j = 0;
							j < this.array[this.order_keys[i]].length;
							j++
						) {
							var element = [];
							for (var k = 0; k < keys.length; k++) {
								element.push({
									elements: [
										{
											text: this.array[
												this.order_keys[i]
											][j][keys[k]],
											type: "text",
										},
									],
									name: keys[k],
									type: "element",
								});
							}
							element = {
								elements: element,
								name: this.order_keys[i],
								type: "element",
							};
							obj.elements[0].elements.push(element);
						}
					}
					obj = convert.json2xml(obj, { compact: false, spaces: 4 });
					this.editor.setValue(obj);
				}
			},
			async sendFileFtp(folder, project_uid) {
				document.body.style.cursor = "wait";
				console.log("ftp");
				var formData = new FormData();

				formData.set("folder", folder);

				var file = new File([this.editor_text], this.name_file, {
					type: "text/xml",
				});
				formData.append(file.name, file);

				var result = await users.sendFileFtp(formData);

				console.log(result);

				if (result.errors) {
					this.$notify({
						group: "info",
						title: "Une erreur c'est produite",
						text: result.errors,
						type: "error",
					});
					var csv = [
						{
							name: file.name,
							folder: folder,
							url:
								result.urls && result.urls.length > 0
									? result.urls[0].url
									: "",
							status: "ko",
							error: result.errors,
							user: store.state.user.identifiant,
							details: this.details,
						},
					];
				} else {
					this.$notify({
						group: "info",
						title: "Envoi effectué",
						type: "success",
					});
					var csv = [
						{
							name: file.name,
							folder: folder,
							url:
								result.urls && result.urls.length > 0
									? result.urls[0].url
									: "",
							status: "ok",
							error: "",
							user: store.state.user.identifiant,
							details: this.details,
						},
					];
				}

				console.log(csv);

				if (project_uid) {
					csv = json2csv.parse(csv, {
						fields: Object.keys(csv[0]),
						fieldNames: Object.keys(csv[0]),
					});

					csv = new Blob([csv], {
						type: "text/plain",
					});

					var formData = new FormData();

					console.log(project_uid);
					console.log(result);

					var treatment_data = await treatments.create(
						project_uid,
						null,
						csv,
						"data.csv",
						null,
						"import",
						formData
					).catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							title: err.response.data.msg,
							type: "error",
						});
					});
					while (
						treatment_data.treatment.resultat != "ok" &&
						treatment_data.treatment.resultat != "ko"
					) {
						await new Promise((resolve) =>
							setTimeout(resolve, 10000)
						);
						treatment_data = await treatments.get(
							treatment_data.treatment.uid
						);
					}
					this.$notify({
						group: "info",
						title: "Traitement après le ftp terminé",
						type: "success",
					});
					console.log("end");
				}
				document.body.style.cursor = "default";
			},
			dowloadXml: async function () {
				utils.saveToFile(this.editor_text, this.name_file);
			},
			viewFile: async function (data, name, details, file) {
				var self = this;
				this.check_update = false;

				if (this.editor) {
					this.editor.destroy();
					this.editor = null;
				}

				if (details) {
					if (typeof details === "string")
						details = JSON.parse(details);
					this.details = details;
					console.log(details);
					if (details.alerts) {
						this.alerts = details.alerts;
						for (var i = 0; i < this.alerts.length; i++) {
							if (typeof this.alerts[i] == "string") {
								this.alerts[i] = {
									variant: "info",
									data: this.alerts[i],
								};
							}
						}
					}

					if (details.origin && details.origin.endsWith(".pdf")) {
						var results_file = await treatments.getFileAlyx(
							details.origin,
							false,
							"arraybuffer"
						);
						this.pdf_buffer = new Uint8Array(results_file);
						this.xml = true;
						this.name_file = name;

						var element = document.getElementById("editor");

						var schema = {
							title: "XML",
							type: "string",
							format: "xml",
							options: {
								ace: {
									maxLines: window.innerHeight / 12.5,
								},
							},
						};

						this.editor = new JSONEditor(element, {
							schema: schema,
							theme: "bootstrap4",
							iconlib: "fontawesome5",
							object_background: "",
						});

						await new Promise((resolve, reject) => {
							self.editor.on("ready", function () {
								if (resolve) resolve();
							});
						});

						this.editor.on("change", function () {
							self.editor_text = self.editor.getValue();
							self.json = convert.xml2js(self.editor_text, {
								compact: false,
							});
							self.array = {};
							if (
								self.json.elements &&
								self.json.elements.length > 0
							) {
								self.main_key = self.json.elements[0].name;
								self.order_keys = [];

								var elements = self.json.elements[0].elements;

								for (var i = 0; i < elements.length; i++) {
									var element = elements[i];
									var name = element.name;
									if (!self.array[name]) {
										self.array[name] = [];
										self.order_keys.push(name);
									}

									if (element.elements) {
										var obj = {};
										for (
											var j = 0;
											j < element.elements.length;
											j++
										) {
											if (
												element.elements[j].elements &&
												element.elements[j].elements
													.length > 0
											) {
												if (
													element.elements[j]
														.elements[0].type ==
													"text"
												)
													obj[
														element.elements[j].name
													] =
														element.elements[
															j
														].elements[0].text;
												else if (
													element.elements[j]
														.elements[0].type ==
													"cdata"
												)
													obj[
														element.elements[j].name
													] =
														"<![CDATA[" +
														element.elements[j]
															.elements[0].cdata +
														"]]>";
											} else if (element.elements[j].name)
												obj[element.elements[j].name] =
													"";
										}
										self.array[name].push(obj);
									}
								}
								for (
									var i = 0;
									i < self.order_keys.length;
									i++
								) {
									self.array[self.order_keys[i]] =
										utils.standardize_json_all(
											self.array[self.order_keys[i]]
										);
								}
								self.$nextTick(async function () {
									for (
										var i = 0;
										i < self.order_keys.length;
										i++
									) {
										self.$refs[
											"tab-" + self.order_keys[i]
										][0].set_data(
											self.array[self.order_keys[i]]
										);
									}
									self.$nextTick(async function () {
										this.check_update = true;
									});
								});
							}
						});
						if (typeof data === "string")
							var data = await treatments.getFileAlyx(
								data,
								false,
								"utf8"
							);
						else
							var data = await treatments.getFile(
								data.item.id,
								data.item.name,
								false,
								"utf8"
							);
						this.editor.setValue(data);
					}
				}
			},
		},
	};
</script>
